const textProps = {
  icon: "fas fa-medal",
  type: "light",
  title: "Excelent Services",
  description:
    "Some quick example text to build on the card title and make up the bulk of the card's content.",
};
export default textProps;
